import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft } from "lucide-react";

export default function Login() {
  const [cpf, setCpf] = useState("");
  const { login, isLoading, user } = useAuth(); // <-- pega usuário/sessão
  const { toast } = useToast();
  const navigate = useNavigate();

  // Redireciona se já estiver logado
  useEffect(() => {
    if (user) {
      navigate("/checkin", { replace: true });
    }
  }, [user, navigate]);

  const formatCPF = (value: string) => {
    const cleanValue = value.replace(/\D/g, "");
    return cleanValue
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  };

  const handleCPFChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatCPF(e.target.value);
    setCpf(formatted);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!cpf || cpf.length < 14) {
      toast({
        title: "CPF inválido",
        description: "Por favor, digite um CPF válido.",
        variant: "destructive",
      });
      return;
    }

    const success = await login(cpf);

    if (success) {
      toast({
        title: "Login realizado!",
        description: "Bem-vindo ao sistema de check-in.",
      });
      navigate("/checkin", { replace: true });
    } else {
      toast({
        title: "CPF não encontrado",
        description: "Este CPF não está inscrito no desafio atual.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-secondary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/pele-bonita.png"
            alt="Campanha Pele Bonita"
            className="mx-auto mb-3 w-32 max-w-sm h-auto object-contain rounded-b-lg"
          />

          <h1 className="text-xl font-bold text-azulescuro mb-2">
            Faça aqui seu check-in diário no desafio!
          </h1>
        </div>

        <Card className="shadow-lg overflow-hidden">
          {/* overflow p/ imagem colar nas bordas */}
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Login</CardTitle>
            <CardDescription>
              <span className="mx-auto mt-2 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-md text-sm font-medium w-fit">
                Digite seu CPF para acessar seus check-ins
              </span>
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="cpf">CPF</Label>
                <Input
                  id="cpf"
                  type="text"
                  placeholder="000.000.000-00"
                  value={cpf}
                  onChange={handleCPFChange}
                  className="h-11"
                  maxLength={14}
                  autoComplete="username"
                  inputMode="numeric"
                />
              </div>

              <Button
                type="submit"
                className="w-full h-11 bg-gradient-primary hover:shadow-glow transition-all duration-300"
                disabled={isLoading}
              >
                {isLoading ? "Verificando..." : "Entrar"}
              </Button>
            </form>

            {/* <div className="mt-6 text-center">
              <Button
                variant="ghost"
                onClick={() => navigate("/")}
                className="text-muted-foreground hover:text-foreground"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Voltar
              </Button>
            </div> */}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
